import { ContentCopy, Delete } from "@mui/icons-material";
import React from "react";
import { Handle } from "react-flow-renderer";
import { useNodeStorage } from "../../../stores/useNodeStorage";

export const nodeShell = {
  width: 210,
  backgroundColor: "#ffffff",
  borderRadius: 8,
  border: "1px solid #e5e7eb",
  boxShadow: "0 8px 18px rgba(15, 23, 42, 0.10)",
  overflow: "hidden",
  position: "relative"
};

export const mutedText = {
  color: "#6b7280",
  fontSize: 11,
  lineHeight: 1.35
};

export const valuePill = (accent) => ({
  background: `${accent}12`,
  borderRadius: 6,
  color: "#374151",
  fontSize: 11,
  lineHeight: 1.35,
  padding: "7px 9px",
  overflow: "hidden",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap"
});

export const NodeCard = ({
  id,
  title,
  accent,
  icon,
  children,
  isConnectable,
  width = 210,
  targetTop = "50%",
  sourceHandles = [{ id: "a", top: "50%" }]
}) => {
  const storageItems = useNodeStorage();

  const handleStyle = {
    background: accent,
    width: 8,
    height: 8
  };

  return (
    <div style={{ ...nodeShell, width }}>
      <Handle
        type="target"
        position="left"
        style={{
          ...handleStyle,
          left: -4,
          top: targetTop
        }}
        isConnectable={isConnectable}
      />

      <div
        style={{
          height: 34,
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          padding: "0 10px 0 12px",
          background: `linear-gradient(180deg, ${accent}1a, ${accent}05)`,
          borderBottom: `1px solid ${accent}1f`
        }}
      >
        <div style={{ display: "flex", alignItems: "center", gap: 8, minWidth: 0 }}>
          <span
            style={{
              width: 21,
              height: 21,
              borderRadius: 5,
              background: `${accent}1f`,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              flexShrink: 0
            }}
          >
            {icon}
          </span>
          <strong
            style={{
              color: accent,
              fontSize: 13,
              fontWeight: 600,
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap"
            }}
          >
            {title}
          </strong>
        </div>

        <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
          <ContentCopy
            onClick={() => {
              storageItems.setNodesStorage(id);
              storageItems.setAct("duplicate");
            }}
            sx={{ width: 15, height: 15, color: "#6b7280", cursor: "pointer" }}
          />
          <Delete
            onClick={() => {
              storageItems.setNodesStorage(id);
              storageItems.setAct("delete");
            }}
            sx={{ width: 15, height: 15, color: "#6b7280", cursor: "pointer" }}
          />
        </div>
      </div>

      <div style={{ padding: 12 }}>
        {children}
      </div>

      {sourceHandles.map((handle) => (
        <Handle
          key={handle.id}
          type="source"
          position="right"
          id={handle.id}
          style={{
            ...handleStyle,
            right: -4,
            top: handle.top
          }}
          isConnectable={isConnectable}
        />
      ))}
    </div>
  );
};
